//
//  SDKDTParentChildMapping.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { TokenGroup } from "../../../../model/groups/SDKTokenGroup";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Types
export const MAX_SORT_ORDER = 1000 * 1000 * 100;
const LAST = MAX_SORT_ORDER + 1;
const sortOrderComparator = (a, b) => { var _a, _b; return ((_a = a.sortOrder) !== null && _a !== void 0 ? _a : LAST) - ((_b = b.sortOrder) !== null && _b !== void 0 ? _b : LAST); };
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Implementation
export function buildParentChildrenMap(elements) {
    const parentIdToChildren = new Map();
    const put = (element) => {
        if (!(element instanceof TokenGroup && element.isRoot)) {
            const parentId = element.parentGroupId;
            // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
            const arr = parentIdToChildren.get(parentId);
            if (arr) {
                arr.push(element);
            }
            else {
                // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
                parentIdToChildren.set(parentId, [element]);
            }
        }
    };
    for (const e of elements) {
        put(e);
    }
    const sortedChildrenMap = new Map();
    for (const [groupId, children] of parentIdToChildren) {
        children.sort(sortOrderComparator);
        sortedChildrenMap.set(groupId, children);
    }
    // fill empty groups data
    for (const possibleGroup of elements) {
        if (possibleGroup instanceof TokenGroup) {
            const key = possibleGroup.id;
            if (!sortedChildrenMap.has(key)) {
                sortedChildrenMap.set(key, []);
            }
        }
    }
    return {
        childrenMap: sortedChildrenMap,
    };
}
